var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Chip, OutlinedInput, } from '@mui/material';
import { cn } from 'hx-util';
import { hearingHealthPartnerLeadsourceMap, salesforceValueToHearingHealthPartnerMap, } from '@/components/user-details/constants/hearing-health-partners.constant';
import { globalLeadSource } from 'hx-analytics/src/functions/url-lead-source/get-url-lead-source.helper';
import { useEffect } from 'react';
import { isSupportedLeadSource } from 'hx-analytics/src/functions/url-lead-source/is-supported-lead-source.helper';
export function HealthAndMemberDiscountsSelect(_a) {
    var _b = _a.form, control = _b.control, setValue = _b.setValue;
    var itemHeight = 48;
    var itemPaddingTop = 8;
    var mappedDiscount = globalLeadSource && isSupportedLeadSource(globalLeadSource)
        ? hearingHealthPartnerLeadsourceMap[globalLeadSource]
        : null;
    useEffect(function () {
        if (!mappedDiscount)
            return;
        setValue('health-and-member-discounts', [mappedDiscount]);
    }, [mappedDiscount]);
    if (mappedDiscount)
        return null;
    return (_jsx(Controller, { name: "health-and-member-discounts", control: control, render: function (_a) {
            var field = _a.field;
            return (_jsxs(FormControl, __assign({ variant: "outlined" }, { children: [_jsx(InputLabel, __assign({ id: "discount-label" }, { children: "Health and Member Discounts" })), _jsx(Select, __assign({}, field, { labelId: "discount-label", id: "discount-select", name: "discount-select", multiple: true, value: field.value || [], onChange: function (event) { return field.onChange(event.target.value); }, input: _jsx(OutlinedInput, { label: "Health and Member Discounts" }), className: "rounded-2xl", renderValue: function (selected) { return (_jsx("div", __assign({ className: "flex gap-1 whitespace-nowrap overflow-hidden" }, { children: selected.map(function (value) { return (_jsx(Chip, { label: salesforceValueToHearingHealthPartnerMap[value], className: "m-0.5 bg-light-gray", size: "small" }, value)); }) }))); }, sx: {
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#3364d9',
                                borderWidth: '2px',
                            },
                            '& #discount-select': {
                                height: '20px',
                                position: 'relative',
                            },
                            '&:hover:not(.Mui-focused)': {
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#3364d9',
                                    borderWidth: '1px',
                                },
                            },
                        }, MenuProps: {
                            PaperProps: {
                                style: {
                                    maxHeight: itemHeight * 4.5 + itemPaddingTop,
                                    width: 250,
                                },
                            },
                        } }, { children: Object.entries(salesforceValueToHearingHealthPartnerMap).map(function (_a) {
                            var value = _a[0], displayName = _a[1];
                            return (_jsx(MenuItem, __assign({ value: value, className: cn('mb-1', {
                                    'bg-light-gray': (field.value || []).includes(value),
                                }) }, { children: displayName }), value));
                        }) })), _jsx(FormHelperText, { children: "Help us find the best price for you" })] })));
        } }));
}
